/* Copyright 2025 Supovia LLC */

let chatAccessToken = null
let chatEmbedOrigin = null

export const getChatAccessToken = () => chatAccessToken
export const getChatEmbedOrigin = () => chatEmbedOrigin

export const setChatAuthorization = (token, embedOrigin) => {
  chatAccessToken = token || null
  chatEmbedOrigin = embedOrigin || null
}

export const clearChatAccessToken = token => {
  if (!token || chatAccessToken === token) {
    chatAccessToken = null
    chatEmbedOrigin = null
  }
}
